const CLICK_ANIMATION_TRIGGER_CLASSNAME = 'click-trigger';
const ClICK_ANIMATION_OFFSCREEN_CLASSNAME = 'click-trigger--offscreen';


// 目标节点
const targetNodes = document.querySelectorAll('details.animation');


// 配置选项
const config = { attributes: true, attributeFilter: ['open'] };

// 创建一个回调函数，当观察到指定的DOM变化时调用
const callback = function(mutationsList, observer) {
    for(let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            const element = mutation.target;
            if (element.hasAttribute('open')) {
                // console.log('元素的 open 属性已被添加');
                const animationEls = element.querySelectorAll("."+CLICK_ANIMATION_TRIGGER_CLASSNAME);
                animationEls.forEach((el, index) => {
                  if (el.hasAttribute('data-cascade')) {
                    el.setAttribute('style', `--animation-order: ${index};`)
                  }
                  el.classList.remove(ClICK_ANIMATION_OFFSCREEN_CLASSNAME)
                })
            } 
            else {
              const element = mutation.target;
                const animationEls = element.querySelectorAll("."+CLICK_ANIMATION_TRIGGER_CLASSNAME);
                animationEls.forEach(el => {
                  if (!el.classList.contains(ClICK_ANIMATION_OFFSCREEN_CLASSNAME)){
                    el.classList.add(ClICK_ANIMATION_OFFSCREEN_CLASSNAME)
                  }
                })
            }
        }
    }
};

// 开始观察目标节点
targetNodes.forEach(element => {
  // 创建一个MutationObserver实例并传入回调函数
  const observer = new MutationObserver(callback);
  observer.observe(element, config);
})